import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
interface PageHeaderProps {
  title: string;
  subtitle?: string;
  backTo?: string;
  backLabel?: string;
  action?: React.ReactNode;
}
export function PageHeader({
  title,
  subtitle,
  backTo,
  backLabel,
  action
}: PageHeaderProps) {
  return <div className="mb-6" data-id="element-198">
      {backTo && <Link to={backTo} className="inline-flex items-center gap-1 text-sm font-semibold text-navy-500 hover:text-gold-600 mb-3 transition-colors" data-id="element-199">
          <ChevronLeft className="w-4 h-4" data-id="element-200" />
          {backLabel || 'Back'}
        </Link>}
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3" data-id="element-201">
        <div data-id="element-202">
          <h1 className="text-2xl sm:text-3xl font-serif font-bold text-navy-900" data-id="element-203">
            {title}
          </h1>
          {subtitle && <p className="text-navy-500 text-sm mt-1" data-id="element-204">{subtitle}</p>}
        </div>
        {action && <div className="shrink-0" data-id="element-205">{action}</div>}
      </div>
    </div>;
}